import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { DataList } from "@/common/DataList";
import type { ActivitiesTabFormValues } from "@/entities/activities-tab-content/model";
import { CompetenceField } from "./CompetenceField";

type Props = {
  personId: string;
  isEditMode: boolean;
  handleEditMode: () => void;
  onSubmit: (data: ActivitiesTabFormValues) => void;
  disabled?: boolean;
};

export const CompetencesList = ({ isEditMode, handleEditMode, onSubmit, disabled }: Props) => {
  const { t } = useTranslation();

  const { control, getValues, trigger } = useFormContext<ActivitiesTabFormValues>();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "competences",
  });

  const onBlur = async () => {
    const isValid = await trigger("competences");

    if (isValid) {
      const formData = getValues();
      onSubmit(formData);
    }
  };

  const onChange = () => {
    trigger("competences");
  };

  const addHandler = () => {
    if (!isEditMode) {
      handleEditMode();
    }

    setTimeout(() => {
      append({
        id: undefined,
        about: "",
        competenceType: {
          name: "",
        },
      });
    }, 0);
  };

  const removeHandler = async (index: number) => {
    remove(index);

    const isValid = await trigger("professionalActivities");

    if (isValid) {
      const formData = getValues();
      onSubmit(formData);
    }
  };

  return (
    <DataList
      data={fields.map((item) => ({
        id: item?.id ?? "",
        label: item?.competenceType?.name ?? "",
        value: item?.about ?? "",
      }))}
      onAddClick={addHandler}
      onTrashClick={removeHandler}
      isEdit={isEditMode}
      title={t("contactsPage.activities.competences", { count: 2 })}
      editNode={(index) => <CompetenceField index={index} onBlur={onBlur} onChange={onChange} />}
      disabled={disabled}
    />
  );
};
